import { TAG_COLOR_LIST } from "./constant";

const TagBordered = ({ color, label }) => (
  <div
    style={{
      background: "#fff",
      borderColor:
        color ?? TAG_COLOR_LIST.find(it => it.label === label)?.color,
      borderRadius: 4,
      borderWidth: "1px 1px 1px 8px",
      borderStyle: "solid",
      color: "#222",
      fontSize: 12,
      fontWeight: 500,
      padding: "1px 6px",
      width: "fit-content",
    }}
  >
    {label}
  </div>
);

export default TagBordered;
